import React from 'react';
import { Row, Button, Col, Spinner, Form } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

function getColumns() {
    let columns = [
        { title: 'Name', field: 'Name' },
        { title: 'Category', field: 'Category' },
        { title: 'ASIN', field: 'ASIN' },
        { title: 'OrderID', field: 'Order Id' },
        { title: 'Date', field: 'Date' },
        { title: 'Qty', field: 'Qty' },
        { title: 'Price(₹)', field: 'Price(₹)' }
    ];
    return columns;
}

const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Category', value: 'Category' },
    { key: 'Name', value: 'Name' },
    { key: 'ASIN', value: 'ASIN' },
    { key: 'OrderID', value: 'Order Id' },
    { key: 'Qty', value: 'Qty' },
    { key: 'Price(₹)', value: 'Price(₹)' }
];
class StoreOrderList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'Category',

        flag: 0,
        alert: 0,
        alertMessage: '',
        data: [],
        serveroptions: [],
        search_key: ''
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            DetailsType: 'Fee_Orders',
            storeTag: this.props.storeTag,
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            DateLabel: 'Date',
            TagLabel: 'Tag'
        };
        

        await RestServices.fetchCollection(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            backArrow: false,
                            flag: 2,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    
                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: 2,
                            alert: 0
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        backArrow: false,
                        flag: 2,
                        alert: 1,
                        alertMessage: err.error
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };
    render() {
        return (
            <div>
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}
                {this.state.flag === 1 && <Spinner animation="border" />}

                <MaterialTable
                    title={'Orders'}
                    columns={[
                        {
                            title: 'Name',
                            field: 'Name',
                            render: (row) => (
                                <div
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={(e) =>
                                        window.open(
                                            'https://www.amazon.in/dp/' +
                                                row.ASIN
                                        )
                                    }
                                >
                                    {row.Name.slice(0, 20) + '...'}
                                </div>
                            )
                        },
                        {
                            title: 'ASIN',
                            field: 'ASIN',
                            render: (row) => (
                                <div
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={(e) =>
                                        window.open(
                                            'https://www.amazon.in/dp/' +
                                                row.ASIN
                                        )
                                    }
                                >
                                    {row.ASIN}
                                </div>
                            )
                        },
                        { title: 'Category', field: 'Category' },
                        { title: 'OrderID', field: 'Order Id' },
                        { title: 'Date', field: 'Date' },
                        { title: 'Qty', field: 'Qty' },
                        { title: 'Price(₹)', field: 'Price(₹)' }
                    ]}
                    data={this.state.data}
                    options={{
                        exportButton: {
                            csv: true
                        },
                        filtering: false,
                        search: false,
                        sorting: false,
                        paging: false,
                        actionsColumnIndex: -1
                    }}
                />

                <div>
                    <hr />
                </div>
                <Row className="custom_pagination">
                    {this.state.StartAt.length > 1 && (
                        <Col>
                            <Button
                                onClick={this.paginatePrev}
                                variant="primary"
                            >
                                Prev
                            </Button>
                        </Col>
                    )}
                    {this.state.StartAt.length < 2 && (
                        <Col>
                            <Button variant="secondary" disabled={true}>
                                Prev
                            </Button>
                        </Col>
                    )}

                    <Col style={{ textAlign: 'center' }}>
                        {'Items per page:'}
                        <select
                            className="items_per_page"
                            onChange={this.handlePageSizeChange}
                            value={this.state.perPage}
                        >
                            {pageSizes.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                        Page: {this.state.StartAt.length}
                    </Col>

                    <Col style={{ textAlign: 'right' }}>
                        {this.state.data.length < this.state.perPage && (
                            <Button variant="secondary" disabled={true}>
                                Next
                            </Button>
                        )}

                        {this.state.data.length >= this.state.perPage && (
                            <Button
                                onClick={this.paginateNext}
                                variant="primary"
                            >
                                Next
                            </Button>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default StoreOrderList;
